/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'ai-mate.agent-message.error': '重新載入聊天',
  'ai-mate.agent-message.error.aup-link-text': '可接受使用政策﻿',
  'ai-mate.agent-message.error.aup-one': '我們無法回應該提示。',
  'ai-mate.agent-message.error.aup-two': '您的提示可能不符合我們的{link}。請嘗試其他提示。',
  'ai-mate.agent-message.error.copy-trace-id': '複製追蹤 ID',
  'ai-mate.agent-message.error.network-error': '似乎有網絡問題。',
  'ai-mate.agent-message.error.resend': '重新傳送訊息',
  'ai-mate.agent-message.error.trace-id': '追蹤 ID：{traceId}',
  'ai-mate.browse-agents-view.close-button': '關閉客服人員檢視',
  'ai-mate.browse-agents-view.header-title': '瀏覽客服人員',
  'ai-mate.chat-header-agent-menu.browse-agents': '瀏覽客服人員',
  'ai-mate.chat-header-agent-menu.chat-with-rovo': '與 Rovo 聊天',
  'ai-mate.chat-header-agent-menu.copy-agent-link-clicked-tooltip': '已複製連結！',
  'ai-mate.chat-header-agent-menu.copy-link': '複製連結',
  'ai-mate.chat-header-agent-menu.create-agent': '建立客服人員',
  'ai-mate.chat-header-agent-menu.create-button-disabled-tooltip': '您沒有在此網站中建立客服人員的權限',
  'ai-mate.chat-header-agent-menu.edit-agent': '編輯客服人員',
  'ai-mate.chat-header-agent-menu.favorite-agent': '我的最愛',
  'ai-mate.chat-header-agent-menu.search-placeholder': '搜尋客服人員',
  'ai-mate.chat-header-agent-menu.switch-agent': '切換到另一個客服人員',
  'ai-mate.chat-header-agent-menu.view-agent-profile': '檢視客服人員設定檔',
  'ai-mate.chat-header.browse-agents-title': '瀏覽客服人員',
  'ai-mate.chat-header.chat-history-title': '聊天記錄',
  'ai-mate.chat-header.default-agent-name': 'Rovo',
  'ai-mate.chat-history.conversationLimit':
    '正在尋找舊的聊天內容嗎？我們在 30 天後會清除聊天記錄，以確保 AI 可順暢執行。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-1': '我最近為哪些 Confluence 頁面做出貢獻？',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-2': '找到指派給我的所有 Jira 工單。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-3': '我們的旅遊政策是什麼？',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-4': '為行銷活動草擬 Confluence 頁面。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-5': '如何建立專案時間軸？',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-6': '寫一封跟進電子郵件給潛在客戶。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-7': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-1': '`人員` 所撰寫的提取要求是什麼？',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-2': '目前 Jira 衝刺尚未解決的提取要求是什麼？',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-3': '`Jira 工作項目` 已經部署了嗎？',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-4': '這個 `提取請求` 的審閱者是誰？',
  'ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-1': '摘要此提取要求。',
  'ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-2': '請說明程式碼變更內容。',
  'ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-3': '建立此提取要求的留言摘要。',
  'ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-1': '說明這個檔案。',
  'ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-2': '`人員` 所撰寫的提取要求是什麼？',
  'ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-3': '這些檔案與哪些 API 或模組互動？',
  'ai-mate.chat-history.empty-state.browse-agents-button-text': '瀏覽客服人員',
  'ai-mate.chat-history.empty-state.chat-with-agent-header': '與 Rovo 客服人員聊天',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-1': '關於這個空間',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-2': '關於這個空間的深入解析',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-3': '空間建議',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-1': '我撰寫的頁面上有什麼新活動嗎？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-10': '`有人` 在我發布的頁面上留言嗎？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-11': '「頁面」中的主要重點是什麼？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-12': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-2': '有沒有新的留言提及我？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-3': '摘要此空間中最近發布的頁面。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-4': '摘要我自上週以來對頁面的貢獻。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-5': '您可以透過更簡單易懂的方式撰寫此 `頁面` 嗎？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-6': '針對專案管理建立遊戲規劃範本。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-7': '我們對常見的客戶問題有什麼研究？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-8': '我的團隊中是否有任何人在本週發布新頁面？',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-9': '`有人` 在本週發布了新頁面嗎？',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1': '您可以改善此頁面上的文字嗎？',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2': '為此頁面撰寫執行摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3': '給我一些其他相關頁面的連結。',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-4': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-1': '關於此頁面',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-2': '此頁面的更多資訊',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-3': '頁面建議',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1': '將我正在閱讀的內容做摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2': '將此頁面上的留言做摘要。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3': '把我當成初學者，向我解釋此頁面。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4': '誰撰寫了這個頁面，以及撰寫者屬於哪一個團隊？',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5': '此頁面在上週有什麼變更嗎？',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-6': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1': '關於此白板',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2': '來自此白板的更多內容',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3': '此白板上的深入解析',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1': '將我正在閱讀的內容做摘要。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-4': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2': '醒目顯示在此處可見的任何模式或趨勢。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3': '識別在此白板中擷取的任何關鍵交辦事項或決策。',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.be-productive': '保持生產力',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.draft-content': '草擬內容',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-information': '尋找資訊',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-people': '尋找人員',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.get-answers': '取得答案',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.measure-productivity': '測量生產力',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.rephrase-content': '換個方式描述內容',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.stay-up-to-date': '保持最新狀態',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.summarize-content': '建立內容摘要',
  'ai-mate.chat-history.empty-state.created-by-label': '<text>建立者為</text> {creatorName}',
  'ai-mate.chat-history.empty-state.intro-text-headline': '{userName}，您好',
  'ai-mate.chat-history.empty-state.intro-text-link-text': '探索 Rovo Chat 和客服人員',
  'ai-mate.chat-history.empty-state.intro-text-subheadline': '選擇對話啟動方式，或詢問任何問題。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1': '尋找本週更新的 Jira 工作項目。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh': '尋找本週更新的 Jira 工作項目。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2': '哪些 Jira 工作項目有最高的優先順序？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh': '哪些 Jira 工作項目有最高的優先順序？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3': '哪些 Jira 工作項目的留言有提及我？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh': '哪些 Jira 工作項目的留言有提及我？',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4': '針對 `Jira 工作項目` 上的留言建立摘要。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh': '針對 `Jira 工作項目` 上的留言建立摘要。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-5': '為使用者案例建立描述範本。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-6': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1': '關於此工作項目',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh': '關於此工作項目',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2': '此工作項目的更多資訊',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh': '此工作項目的更多資訊',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3': '有關此工作項目的深入解析',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh': '有關此工作項目的深入解析',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4': '工作項目建議',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh': '工作項目建議',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1': '有沒有與此類似的 Jira 工作項目？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh': '有沒有與此類似的 Jira 工作項目？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2': '如何改善描述？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3': '我可以將哪些標籤新增至此工作項目？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh': '我可以將哪些標籤新增至此工作項目？',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-4': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-1': '關於此專案',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-2': '有關此專案的深入解析',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-3': '此專案的更多資訊',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-4': '專案建議',
  'ai-mate.chat-history.empty-state.jira-project-prompt-1': '哪一項工作已經有一陣子沒有進展？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10': '尋找類似的 Jira 工作項目並加以分組。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh': '尋找類似的 Jira 工作項目並加以分組。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11': '是否有任何 Jira 工作項目並未連結至父系工作項目？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh':
    '是否有任何 Jira 工作項目並未連結至父系工作項目？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12': '調整 `Jira 工作項目` 描述以符合最佳做法。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh':
    '調整 `Jira 工作項目` 描述以符合最佳做法。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13': '針對 `Jira 工作項目` 上的留言建立摘要。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh':
    '針對 `Jira 工作項目` 上的留言建立摘要。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14': '為使用者案例建立描述範本。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh': '為使用者案例建立描述範本。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-15': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2': '有任何 Jira 工作項目被封鎖嗎？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh': '有任何 Jira 工作項目被封鎖嗎？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3': '列出目前「進行中」的 Jira 工作項目，並按受託人加以分組。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh':
    '列出目前「進行中」的 Jira 工作項目，並按受託人加以分組。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4': '有多少工作項目指派給 `人員`？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh': '有多少工作項目指派給「某人」？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5': '是否有 `人員` 在此衝刺中的 Jira 工作項目上留言？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh':
    '是否有 `人員` 在此衝刺中的 Jira 工作項目上留言？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6': '哪些 Jira 工作項目並未指派？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh': '哪些 Jira 工作項目並未指派？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7': '哪些 Jira 工作項目處於尚未解決的狀態最久？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh': '哪些 Jira 工作項目處於待處理狀態最久？',
  'ai-mate.chat-history.empty-state.jira-project-prompt-8': '誰有最多任務？',
  'ai-mate.chat-history.empty-state.message': '獲得答案、產生新構想，並加速日常工作。',
  'ai-mate.chat-history.empty-state.suggestion1': '我是否有任何逾期的工作項目？',
  'ai-mate.chat-history.empty-state.suggestion2': '接下來我應該處理什麼？',
  'ai-mate.chat-history.empty-state.suggestion3': '撰寫本週更新',
  'ai-mate.chat-history.empty-state.unknown-llm-label-1': '建議',
  'ai-mate.chat-history.loading-state.rovo-is-thinking': '{name} 正在思考',
  'ai-mate.chat-history.message-post-research.title': '研究完成',
  'ai-mate.chat-history.message-pre-research.title': '建立研究計畫',
  'ai-mate.chat-history.message-research-notification-button-text': '完成時通知我',
  'ai-mate.chat-history.message-research-notification-confirmation-label-text': '完成後我們會通知您',
  'ai-mate.chat-history.message-research-notification-text':
    '深入研究可能需要幾分鐘的時間，但結果值得等待。您可以繼續工作，只需將此聊天視窗保持開啟即可。',
  'ai-mate.chat-history.message-research-refresh.research-step-title-placeholder': '正在搜尋相關資訊...',
  'ai-mate.chat-history.message-research-refresh.rovo-is-thinking': 'Rovo 正在思考',
  'ai-mate.chat-history.message-research-refresh.steps': '第 {count} 步 (共 {count} 步)',
  'ai-mate.chat-history.message-research.research-completed-notification-body': '您的研究已完成，可供檢視。',
  'ai-mate.chat-history.message-research.research-completed-notification-title': 'Rovo Chat 已完成研究',
  'ai-mate.chat-history.message-research.research-expandable.collapse': '摺疊',
  'ai-mate.chat-history.message-research.research-expandable.expand': '展開',
  'ai-mate.chat-history.message-research.research-step-title-placeholder': '搜尋相關資訊...',
  'ai-mate.chat-history.message-research.sources-title': '{count, plural, other {{count} 個來源}}',
  'ai-mate.chat-history.message-research.step-loaded-icon-label': '已載入步驟',
  'ai-mate.chat-history.message-research.step-loading-icon-label': '正在載入步驟',
  'ai-mate.chat-history.message-research.title.v2': '顯示研究活動',
  'ai-mate.chat-history.message-research.view-sources-button-label': '{count, plural, other {{count} 個來源}}',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': '取消',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': '確認',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button': '完成此動作時發生問題',
  'ai-mate.chat-input.actions-button.label': '插入元素',
  'ai-mate.chat-input.add-a-link-button.label': '新增連結',
  'ai-mate.chat-input.chat-input-assistive-label': '撰寫提示以開始使用',
  'ai-mate.chat-input.chat-input-continue-assistive-label': '提出後續問題',
  'ai-mate.chat-input.chat-input-continue-conversation-placeholder': '描述您接下來想知道或執行的事',
  'ai-mate.chat-input.chat-input-default-placeholder': '撰寫提示、@某人，或將 / 用於動作',
  'ai-mate.chat-input.deep-research-button.label': '深入研究',
  'ai-mate.chat-input.deleted-agent-icon-label': '已刪除客服人員',
  'ai-mate.chat-input.deleted-agent-start-new-chat': '開始新聊天',
  'ai-mate.chat-input.deleted-agent-warning': '此客服人員已被刪除。',
  'ai-mate.chat-input.dr.disabled.tooltip': '目前，客服人員無法使用深入研究。',
  'ai-mate.chat-input.drag-and-drop-message': '拖放以新增背景資訊，用於取得更好的結果',
  'ai-mate.chat-input.file-close-icon-label': '移除檔案',
  'ai-mate.chat-input.link-type-ahead-button.label': '新增連結',
  'ai-mate.chat-input.mention-someone-button.label': '提及某人或團隊',
  'ai-mate.chat-input.mention-type-ahead-button.label': '提及某人',
  'ai-mate.chat-input.notifications-enabled': '已啟用通知',
  'ai-mate.chat-input.notifications-enabled-body': '您可以繼續在另一個分頁中工作，我們將在您的研究完成時通知您！',
  'ai-mate.chat-input.notifications-enabled-button': '啟用通知',
  'ai-mate.chat-input.notifications-enabled-notification-content': '您的深度研究查詢完成後，將會收到通知。',
  'ai-mate.chat-input.notifications-enabled-notification-title': '通知已啟用！',
  'ai-mate.chat-input.notifications-not-enabled': '未啟用通知',
  'ai-mate.chat-input.notifications-not-enabled-body':
    '深度研究很強大，但可能需要更長時間才能完成。如果您啟用通知，可以繼續在另一個分頁中工作，完成後我們會通知您！',
  'ai-mate.chat-input.open-chat-input-buttons-label': '打開聊天輸入的按鈕',
  'ai-mate.chat-input.search.disabled.tooltip': '目前，客服人員無法使用網頁搜尋。',
  'ai-mate.chat-input.send-button.label': '提交',
  'ai-mate.chat-input.stop-generating-button.label': '停止產生',
  'ai-mate.chat-input.store-user-messages.label': '記錄此訊息以協助我們改善回答品質',
  'ai-mate.chat-input.web-search-button-extended.label': '網頁搜尋',
  'ai-mate.chat-input.web-search-button.label': '搜尋',
  'ai-mate.chat-main-header.back-button.label': '返回',
  'ai-mate.chat-main-header.copy-agent-link-button.label': '複製連結',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.body':
    '正在進行深入研究。如果您繼續操作，我們將無法在背景中處理您的提示。',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.button': '關閉聊天',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.cancel-button': '取消',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.close-button': '關閉',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.title': '關閉聊天',
  'ai-mate.chat-main-header.default-agent-name': '聊天',
  'ai-mate.chat-main-header.edit-agent-button.label': '編輯',
  'ai-mate.chat-main-header.link-copied-to-profile': '已複製 URL',
  'ai-mate.conversation-assistant.finalize-space.space-permissions.copy-option-label': '從另一個空間複製',
  'ai-mate.conversation-assistant.finalize-space.space-permissions.default-option-label': '預設',
  'ai-mate.conversation-assistant.finalize-space.space-permissions.private-option-label': '只有我能看見',
  'ai-mate.conversation-list-refresh.search-input-placeholder.label': '搜尋所有聊天…',
  'ai-mate.conversation-list-refresh.title.label': '所有聊天',
  'ai-mate.feedback-collector.share-thoughts-label': '摘要',
  'ai-mate.feedback-collector.share-thoughts-placeholder': '讓我們知道您的想法',
  'ai-mate.footer.debug-button.tooltip': '除錯',
  'ai-mate.footer.footer-message': '使用人工智慧。驗證結果。',
  'ai-mate.footer.local-frontend-components.insert-agent-id-label': '請插入 agentId',
  'ai-mate.footer.rovo-beta-label': '測試版',
  'ai-mate.footer.rovo-branding-label': '{logo} Rovo',
  'ai-mate.footer.rovo-branding-label-updated': 'Rovo {logo}',
  'ai-mate.local-frontend-components.agent-embed-button-label': '客服人員嵌入',
  'ai-mate.local-frontend-components.call-an-api-button-label': '呼叫 API',
  'ai-mate.local-frontend-components.close-label': '關閉本機元件',
  'ai-mate.local-frontend-components.close-simulated-fullscreen-button-label': '關閉模擬的全螢幕',
  'ai-mate.local-frontend-components.create-edit-button-label': '建立/編輯客服人員',
  'ai-mate.local-frontend-components.create-release-button-label': '建立 Jira 版本',
  'ai-mate.local-frontend-components.modal-title': '本機元件',
  'ai-mate.local-frontend-components.pubsub-events-button-label': '發布/訂閱事件',
  'ai-mate.local-frontend-components.simulated-fullscreen-button-label': '模擬全螢幕',
  'ai-mate.placeholder.c-suite.alignment': '請 Rovo 建立跨職能協調白板',
  'ai-mate.placeholder.c-suite.executive-decisions': '請 Rovo 透過文件即時追蹤高層決策',
  'ai-mate.placeholder.c-suite.executive-summary': '請 Rovo 為看板撰寫執行摘要',
  'ai-mate.placeholder.c-suite.market-expansion': '請 Rovo 擬定全面的市場擴張規劃',
  'ai-mate.placeholder.c-suite.strategy': '請 Rovo 擬定公司策略頁面，包括願景、使命與優先要務',
  'ai-mate.placeholder.c-suite.three-year-vision': '請 Rovo 建立三年願景白板',
  'ai-mate.placeholder.customer-service.escalation': '請 Rovo 記錄向上呈報程序',
  'ai-mate.placeholder.customer-service.faq': '請 Rovo 撰寫常見問答頁面',
  'ai-mate.placeholder.customer-service.incident-tracker': '請 Rovo 開始建立即時事件追蹤器文件',
  'ai-mate.placeholder.customer-service.knowledge-base': '請 Rovo 擬定用於解決問題的知識庫文章',
  'ai-mate.placeholder.customer-service.script': '請 Rovo 擬定支援指令碼',
  'ai-mate.placeholder.customer-service.workflow': '請 Rovo 建立工作流程改進白板',
  'ai-mate.placeholder.data-science.data-cleaning': '請 Rovo 記錄資料清理的執行步驟',
  'ai-mate.placeholder.data-science.exploration': '請 Rovo 開始協作資料探索文件',
  'ai-mate.placeholder.data-science.pipeline-diagram': '請 Rovo 建立資料管道圖表白板',
  'ai-mate.placeholder.data-science.project-analysis': '請 Rovo 擬定專案分析摘要',
  'ai-mate.placeholder.data-science.research-template': '請 Rovo 建立可重複使用的研究範本',
  'ai-mate.placeholder.data-science.whiteboard': '請 Rovo 建立可視化白板模型',
  'ai-mate.placeholder.design.decision': '請 Rovo 撰寫設計決策文件',
  'ai-mate.placeholder.design.end-to-end-visualization': '請 Rovo 建立端對端視覺化白板',
  'ai-mate.placeholder.design.project-kickoff': '請 Rovo 擬定專案啟動頁面',
  'ai-mate.placeholder.design.review': '請 Rovo 建立協作式設計審查文件',
  'ai-mate.placeholder.design.spec': '請 Rovo 建立包含使用者案例、主要流程及輔助工具附註的設計規格範本',
  'ai-mate.placeholder.design.voice-tone': '請 Rovo 擬定聲音個性和語氣指南',
  'ai-mate.placeholder.engineering.instrumentation-spec': '請 Rovo 撰寫檢測規格',
  'ai-mate.placeholder.engineering.sprint-planning': '請 Rovo 建立衝刺規劃白板',
  'ai-mate.placeholder.engineering.standup-notes': '請 Rovo 建立站立式會議記錄',
  'ai-mate.placeholder.engineering.team-velocity': '請 Rovo 擬定團隊速度報告',
  'ai-mate.placeholder.engineering.tech-design': '請 Rovo 撰寫技術設計文件',
  'ai-mate.placeholder.engineering.write-api-documentation': '請 Rovo 撰寫 API 說明文件',
  'ai-mate.placeholder.finance.account-plan': '請 Rovo 擬定客戶規劃',
  'ai-mate.placeholder.finance.budget-variance': '請 Rovo 建立協作式預算差異分析文件',
  'ai-mate.placeholder.finance.compliance-checklist': '請 Rovo 建立合規性檢查清單',
  'ai-mate.placeholder.finance.market-trend': '請 Rovo 撰寫市場趨勢分析',
  'ai-mate.placeholder.finance.quarterly-outcomes': '請 Rovo 撰寫季度成果文件，凸顯主要交易、風險與行動方案',
  'ai-mate.placeholder.finance.quarterly-planning': '請 Rovo 建立季度規劃白板',
  'ai-mate.placeholder.generic.brainstorm': '請 Rovo 建立腦力激盪白板',
  'ai-mate.placeholder.generic.checklist': '請 Rovo 建立檢查清單',
  'ai-mate.placeholder.generic.decision-doc': '請 Rovo 撰寫決策制定文件',
  'ai-mate.placeholder.generic.meeting-notes': '請 Rovo 擬定會議記錄',
  'ai-mate.placeholder.generic.project-overview': '請 Rovo 擬定專案概觀頁面',
  'ai-mate.placeholder.generic.tech-docs': '請 Rovo 擬定技術說明文件',
  'ai-mate.placeholder.hr.company-policy': '請 Rovo 擬定新公司政策頁面',
  'ai-mate.placeholder.hr.faq': '請 Rovo 撰寫常見人事問題的問答頁面',
  'ai-mate.placeholder.hr.interview-notes': '請 Rovo 在即時文件中記錄面試筆記',
  'ai-mate.placeholder.hr.interview-process': '請 Rovo 建立面試流程改進白板',
  'ai-mate.placeholder.hr.performance-template': '請 Rovo 擬定績效考核記錄範本',
  'ai-mate.placeholder.hr.quarterly-review': '請 Rovo 建立協作式季度人力資源策略檢討',
  'ai-mate.placeholder.it.infrastructure-upgrade': '請 Rovo 建立基礎設施升級腦力激盪',
  'ai-mate.placeholder.it.network-diagram': '請 Rovo 建立網路架構圖白板',
  'ai-mate.placeholder.it.onboarding-checklist': '請 Rovo 撰寫新進員工入職檢查清單',
  'ai-mate.placeholder.it.policy-procedure': '請 Rovo 擬定新的 IT 政策或程序',
  'ai-mate.placeholder.it.tech-docs': '請 Rovo 撰寫技術說明文件',
  'ai-mate.placeholder.it.troubleshooting-guide': '請 Rovo 擬定疑難排解指南',
  'ai-mate.placeholder.legal.compliance': '請 Rovo 擬定新的合規政策',
  'ai-mate.placeholder.legal.compliance-checklist': '請 Rovo 建立合規性檢查清單',
  'ai-mate.placeholder.legal.compliance-review': '請 Rovo 撰寫合規性審查規劃文件',
  'ai-mate.placeholder.legal.contract-diagram': '請 Rovo 透過白板繪製合約審查與核准流程圖',
  'ai-mate.placeholder.legal.contract-negotiations': '請 Rovo 建立即時合約協商追蹤器文件',
  'ai-mate.placeholder.legal.risk-assessment': '請 Rovo 透過白板建立風險評估腦力激盪',
  'ai-mate.placeholder.marketing.battle-card': '請 Rovo 建立推銷用競爭戰情卡',
  'ai-mate.placeholder.marketing.buyer-personas': '請 Rovo 擬定三個詳細的買家角色',
  'ai-mate.placeholder.marketing.campaign': '請 Rovo 開始行銷活動腦力激盪白板',
  'ai-mate.placeholder.marketing.gtm': '請 Rovo 建立 GTM 規劃文件',
  'ai-mate.placeholder.marketing.press-release': '請 Rovo 撰寫發布新聞稿',
  'ai-mate.placeholder.marketing.reactivation-campaign': '請 Rovo 使用白板建立舊客戶回流活動腦力激盪',
  'ai-mate.placeholder.operations.compliance': '請 Rovo 建立合規性檢查清單',
  'ai-mate.placeholder.operations.incident-log': '請 Rovo 擬定即時事件記錄',
  'ai-mate.placeholder.operations.process-improvement': '請 Rovo 建立流程改進白板',
  'ai-mate.placeholder.operations.procurement': '請 Rovo 建立採購流程白板',
  'ai-mate.placeholder.operations.review': '請 Rovo 擬定營運檢討摘要',
  'ai-mate.placeholder.operations.sop': '請 Rovo 撰寫 SOP 文件',
  'ai-mate.placeholder.product.prd': '請 Rovo 建立產品需求文件',
  'ai-mate.placeholder.product.prioritization': '請 Rovo 建立優先順序架構白板',
  'ai-mate.placeholder.product.quarterly-goals': '請 Rovo 撰寫季度目標狀態更新',
  'ai-mate.placeholder.product.retro': '請 Rovo 為產品發布建立回顧白板',
  'ai-mate.placeholder.product.roadmap': '請 Rovo 建立產品藍圖時間軸',
  'ai-mate.placeholder.product.strategy': '請 Rovo 撰寫策略規劃頁面',
  'ai-mate.placeholder.program.communication': '請 Rovo 撰寫相關人員溝通規劃',
  'ai-mate.placeholder.program.decisions': '請 Rovo 摘要最近的重要決策和動作',
  'ai-mate.placeholder.program.risk-brainstorm': '請 Rovo 建立計劃風險白板腦力激盪',
  'ai-mate.placeholder.program.risk-register': '請 Rovo 草擬協作風險清冊',
  'ai-mate.placeholder.program.roadmap': '請 Rovo 建立藍圖規劃文件',
  'ai-mate.placeholder.program.status-report': '請 Rovo 擬定計劃狀態報告',
  'ai-mate.placeholder.sales.account-history': '請 Rovo 摘要帳戶歷史記錄',
  'ai-mate.placeholder.sales.discovery-questions': '請 Rovo 擬定 10 到 15 個初次通話的探索性問題',
  'ai-mate.placeholder.sales.ebc-agenda': '請 Rovo 建立 EBC 會議議程',
  'ai-mate.placeholder.sales.enablement': '請 Rovo 建立腦力激盪白板',
  'ai-mate.placeholder.sales.pipeline-visualization': '請 Rovo 建立管道視覺化白板',
  'ai-mate.placeholder.sales.playbook': '請 Rovo 擬定銷售使用案例頁面',
  'ai-mate.prompt-cards.more-ideas': '更多構想',
  'ai-mate.prompt-cards.show-less': '顯示較少',
  'ai-mate.pubsub-listener.forge-auth-faiure-message': '確認失敗，請稍後再試一次。',
  'ai-mate.pubsub-listener.forge-auth-success-message': '確認成功，請重新傳送提示。',
  'ai-mate.sidebar.agents-icon.text': '客服人員',
  'ai-mate.sidebar.agents-icon.tooltip': '瀏覽 Rovo 客服人員',
  'ai-mate.sidebar.chat-icon.text': '聊天',
  'ai-mate.sidebar.chat-icon.tooltip': '與 Rovo 聊天',
  'ai-mate.sidebar.debug-mode-icon.tooltip': '除錯',
  'ai-mate.sidebar.get-help-icon.tooltip': '取得協助',
  'ai-mate.sidebar.give-feedback-icon.tooltip': '提供意見反應',
  'ai-mate.sidebar.history-icon.text': '歷程記錄',
  'ai-mate.sidebar.history-icon.tooltip': '檢視您的聊天歷史記錄',
  'ai-mate.smart-create.title': '您今天要建立什麼？',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-description': '驗證檔案時發生錯誤，請再試一次。',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-title': '無法驗證檔案',
  'ai-mate.upload-files-to-conversation.file-invalid-icon-label': '檔案無效',
  'ai-mate.upload-files-to-conversation.file-rai-policy-violation':
    '檔案可能不符合我們的《可接受使用政策》。請試試看不同的檔案。',
  'ai-mate.upload-files-to-conversation.invalid-files-description':
    '{count, plural, other {不支援下列檔案：「{fileNames}」。原因：{reasons}}}',
  'ai-mate.upload-files-to-conversation.invalid-files-title':
    '{count, plural, other {不支援 {count,number} 個檔案類型}}',
  'ai-mate.upload-files-to-conversation.unknown-error': '上傳檔案時發生錯誤。請再試一次。',
  'ai-mate.upload-files-to-conversation.unsupported-file': '不支援的檔案類型',
  'ai-mate.upload-files-to-conversation.validation-error-file-name-missing': '缺少檔案名稱',
  'ai-mate.upload-files-to-conversation.validation-error-file-too-large': '檔案大小太大',
  'ai-mate.upload-files-to-conversation.validation-error-invalid-content-type': '不支援檔案類型',
  'ai-mate.upload-files-to-conversation.validation-error-missing-error-code': '驗證結果未知',
  'ai-mate.upload-files-to-conversation.validation-error-not-found': '找不到驗證結果',
  'ai-mate.upload-files-to-conversation.validation-error-unknown-error': '由於未知原因，無法驗證檔案',
  'chat-history.deep-research-rate-limit-warning': '請在 24 小時後再試一次。',
  'chat-history.deep-research-rate-limit-warning-description': '您已超過深度研究的速率上限。請在 24 小時後再試一次。',
  'chat-history.rate-limit-warning': '{secondsRemaining, plural, other {請等待 {secondsRemaining,number} 秒}}',
  'chat-history.rate-limit-warning-description': '訊息傳送過快，請稍候。',
  'chatHistory.storeAssistant.badResponseLabel': '回應不良',
  'chatHistory.storeAssistant.copyResponseLabel': '複製',
  'chatHistory.storeAssistant.debugLabel': '對回應進行偵錯',
  'chatHistory.storeAssistant.goodResponseLabel': '回應良好',
  'rovo-chat.agent-debug-modal.action-container.expand-label': '展開/摺疊',
  'rovo-chat.agent-debug-modal.action-container.input-label': '輸入',
  'rovo-chat.agent-debug-modal.action-container.lines-rendered-label':
    '{total, plural, other {目前顯示 {current} 行/共 {total} 行}}',
  'rovo-chat.agent-debug-modal.action-container.output-label': '輸出',
  'rovo-chat.agent-debug-modal.action-container.show-more-label': '顯示更多',
  'rovo-chat.agent-debug-modal.cancel': '關閉',
  'rovo-chat.agent-debug-modal.copy-all-button': '複製全部',
  'rovo-chat.agent-debug-modal.copy-all-tooltip': '已複製到剪貼簿',
  'rovo-chat.agent-debug-modal.error-message': '擷取偵錯記錄時發生錯誤',
  'rovo-chat.agent-debug-modal.header-text': '回應詳細資料',
  'rovo-chat.agent-debug-modal.header-text-description':
    '如果您提出關於此回應的支援工單，您可以將這些詳細資料提供給我們的支援團隊。',
  'rovo-chat.agent-debug-modal.message-info.agent-id-label': '客服人員 ID',
  'rovo-chat.agent-debug-modal.message-info.agent-label': '客服人員',
  'rovo-chat.agent-debug-modal.message-info.copy-to-clipboard-label': '複製',
  'rovo-chat.agent-debug-modal.message-info.copy-to-clipboard-tooltip': '複製到剪貼簿',
  'rovo-chat.agent-debug-modal.message-info.default-scenario-label': '預設案例',
  'rovo-chat.agent-debug-modal.message-info.scenario-label': '案例',
  'rovo-chat.agent-debug-modal.message-info.trace-id-label': '要求 ID',
  'rovo-chat.agent-debug-modal.message-not-found-message': '在對話中找不到訊息',
  'rovo-chat.agent-debug-modal.skills-description': '客服人員用於提供回應的技能。',
  'rovo-chat.agent-debug-modal.skills-label': '所使用的技能',
  'rovo-chat.agent-debug-modal.title': '對回應進行偵錯',
  'rovo-chat.agent-debug-modal.tools-fetching-error-message': '擷取工具時發生錯誤',
  'rovo-chat.chat-input.editor-context-banner.editor-context-toggle-label': '使用此背景資訊',
  'rovo-chat.data-sculptor-modal.cancel': '取消',
  'rovo-chat.data-sculptor-modal.no-data': '無資料',
  'rovo-chat.data-sculptor-modal.title': '分析',
  'rovo-chat.file-upload-button.label': '上傳檔案',
  'rovo-chat.file-upload-button.max-files-label': '{maxFiles, plural, other {已達到 {maxFiles,number} 個檔案的上限}}',
  'rovo-chat.store-assistant.beta-features-message': '提供的答案使用了測試版功能。',
  'rovo-chat.store-assistant.beta-lozenge': '測試版',
  'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label': '插入到頁面',
  'rovo-chat.store-assistant.insert-replace.generic-insert-button-label': '插入',
  'rovo-chat.store-assistant.insert-replace.jira-insert-button-label': '插入到工作項目',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': '取代所選範圍',
  'rovo-chat.store-assistant.insert-replace.tooltip-message':
    '您目前的背景資訊不支援此功能。請嘗試選取、撰寫或編輯頁面上的文字。',
  'rovo-chat.store-assistant.sources-title': '來源：',
  'smart-creation.preview.add-to-space-popup.cancel-button': '取消',
  'smart-creation.preview.add-to-space-popup.confirm-button': '新增',
  'smart-creation.preview.add-to-space-popup.content-type-buttons-label': '選取類型',
  'smart-creation.preview.add-to-space-popup.content-type-live-doc': '即時文件',
  'smart-creation.preview.add-to-space-popup.content-type-page': '頁面',
  'smart-creation.preview.add-to-space-popup.error-flag.description': '重新開啟您的 Rovo 聊天，然後再試一次。',
  'smart-creation.preview.add-to-space-popup.error-flag.title': '我們無法將此新增到空間',
  'smart-creation.preview.add-to-space-popup.no-parent-error': '請選取父系',
  'smart-creation.preview.add-to-space-popup.no-space-error': '請選取空間',
  'smart-creation.preview.add-to-space-popup.parent-label': '父系',
  'smart-creation.preview.add-to-space-popup.restrict-access-label': '設定為私密',
  'smart-creation.preview.add-to-space-popup.select-space-label': '選取空間',
  'smart-creation.preview.add-to-space-popup.title.heading': '新增到 Confluence 空間',
  'smart-creation.preview.addToSpaceButton.closeIconLabel': '關閉',
  'smart-creation.preview.addToSpaceButton.v2': '新增至 Confluence',
  'smart-creation.preview.create-a-space-popup.title': '建立空間',
  'smart-creation.preview.createAllButton': '在「{projectName}」中建立全部',
  'smart-creation.preview.createSpaceButton': '建立空間',
  'smart-creation.preview.createSpaceButton.closeIconLabel': '關閉',
  'smart-creation.preview.error-flag.description':
    '我們在建立這些工作項目時遇到一些問題。請重新整理頁面，然後再試一次。',
  'smart-creation.preview.error-flag.title': '無法建立這些工作項目',
  'smart-creation.preview.lozenge': '預覽 • 只有您能夠看見',
};
